import { render } from "./DialogHeader.vue?vue&type=template&id=f3f5c576"
import script from "./DialogHeader.vue?vue&type=script&lang=js"
export * from "./DialogHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__